import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';

export interface LinkDetails {
    name: string,
    link: string,
    Icon ?: any
}

const contactInfo: {[service: string]: LinkDetails} = {
    twitter: {
        name: "Twitter",
        link: "https://twitter.com/azuragasetsu",
        Icon: TwitterIcon
    },

    youtube: {
        name: "YouTube",
        link: "https://www.youtube.com/@azuraga_melody",
        Icon: YouTubeIcon
    },

    soundcloud: {
        name: "SoundCloud",
        link: "https://soundcloud.com/azuragasetsu",
    },

    bandcamp: {
        name: "BandCamp",
        link: "https://azuraga.bandcamp.com/",
    }

}

export default contactInfo
